(function () {
  function setupReveal() {
    var items = document.querySelectorAll('[data-reveal]');
    if (!items.length || !window.IntersectionObserver) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  function markSections() {
    // Reveal each main-content section as a whole, skipping header/footer
    // chrome and anything already marked individually.
    var main = document.querySelector('#MainContent, main');
    if (!main) return;
    var sections = main.querySelectorAll(':scope > .shopify-section');
    sections.forEach(function (section, index) {
      if (index === 0) return; // first section (often the hero) stays visible immediately
      if (!section.hasAttribute('data-reveal')) {
        section.setAttribute('data-reveal', '');
      }
    });
  }

  function formatNumber(value) {
    // Always group every 3 digits with a space, matching the site's own
    // number formatting — toLocaleString('pl-PL') skips grouping below
    // 10 000, which reads as inconsistent next to 5-digit stats.
    return Math.round(value)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  function setupCounters() {
    var counters = document.querySelectorAll('[data-count-to]');
    if (!counters.length || !window.IntersectionObserver) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          animateCount(entry.target);
        });
      },
      { threshold: 0.4 }
    );

    counters.forEach(function (counter) {
      observer.observe(counter);
    });
  }

  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-count-to'));
    if (isNaN(target)) return;
    var suffix = el.getAttribute('data-count-suffix') || '';
    var duration = 1200;
    var start = null;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.textContent = formatNumber(target) + suffix;
      return;
    }

    function step(timestamp) {
      if (start === null) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = formatNumber(target * eased) + suffix;
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    }

    window.requestAnimationFrame(step);
  }

  function init() {
    markSections();
    setupReveal();
    setupCounters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
